import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "nontax-compare-panel" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "info-row" }
const _hoisted_5 = { class: "info-item" }
const _hoisted_6 = { class: "info-value highlight" }
const _hoisted_7 = { class: "info-item" }
const _hoisted_8 = { class: "info-value" }
const _hoisted_9 = {
  key: 0,
  class: "setting-section"
}
const _hoisted_10 = { class: "setting-row" }
const _hoisted_11 = { class: "setting-item lunch-setting" }
const _hoisted_12 = { class: "setting-item" }
const _hoisted_13 = {
  key: 1,
  class: "modal-content"
}
const _hoisted_14 = { class: "comparison-table-wrapper" }
const _hoisted_15 = { class: "comparison-table" }
const _hoisted_16 = { class: "sticky-col col-no text-center" }
const _hoisted_17 = { class: "sticky-col-name" }
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-right" }
const _hoisted_20 = { class: "before-cell text-right" }
const _hoisted_21 = { class: "before-cell text-right" }
const _hoisted_22 = { class: "before-cell text-right" }
const _hoisted_23 = { class: "before-cell text-right" }
const _hoisted_24 = { class: "after-cell text-right" }
const _hoisted_25 = { class: "after-cell text-right" }
const _hoisted_26 = { class: "after-cell text-right" }
const _hoisted_27 = { class: "after-cell text-right" }
const _hoisted_28 = { class: "risk-cell text-right font-bold" }
const _hoisted_29 = { class: "total-row" }
const _hoisted_30 = { class: "text-right font-bold" }
const _hoisted_31 = { class: "before-cell text-right font-bold" }
const _hoisted_32 = { class: "before-cell text-right font-bold" }
const _hoisted_33 = { class: "before-cell text-right font-bold" }
const _hoisted_34 = { class: "before-cell text-right font-bold" }
const _hoisted_35 = { class: "after-cell text-right font-bold" }
const _hoisted_36 = { class: "after-cell text-right font-bold" }
const _hoisted_37 = { class: "after-cell text-right font-bold" }
const _hoisted_38 = { class: "after-cell text-right font-bold" }
const _hoisted_39 = { class: "risk-cell text-right font-bold" }
const _hoisted_40 = { class: "summary-section" }
const _hoisted_41 = { class: "summary-cards" }
const _hoisted_42 = { class: "summary-card before-card" }
const _hoisted_43 = { class: "card-desc" }
const _hoisted_44 = { class: "summary-row" }
const _hoisted_45 = { class: "value" }
const _hoisted_46 = { class: "summary-row" }
const _hoisted_47 = { class: "value" }
const _hoisted_48 = { class: "summary-row" }
const _hoisted_49 = { class: "value" }
const _hoisted_50 = { class: "summary-row" }
const _hoisted_51 = { class: "value" }
const _hoisted_52 = { class: "summary-row total" }
const _hoisted_53 = { class: "value" }
const _hoisted_54 = { class: "summary-card after-card" }
const _hoisted_55 = { class: "summary-row" }
const _hoisted_56 = { class: "value" }
const _hoisted_57 = { class: "summary-row" }
const _hoisted_58 = { class: "value" }
const _hoisted_59 = { class: "summary-row" }
const _hoisted_60 = { class: "value" }
const _hoisted_61 = { class: "summary-row" }
const _hoisted_62 = { class: "value" }
const _hoisted_63 = { class: "summary-row total" }
const _hoisted_64 = { class: "value" }
const _hoisted_65 = { class: "summary-card diff-card" }
const _hoisted_66 = { class: "summary-row highlight-row" }
const _hoisted_67 = { class: "value" }
const _hoisted_68 = { class: "summary-row" }
const _hoisted_69 = { class: "summary-row" }
const _hoisted_70 = { class: "summary-row total" }
const _hoisted_71 = { class: "summary-row info" }
const _hoisted_72 = { class: "summary-card risk-card" }
const _hoisted_73 = { class: "summary-row highlight-row" }
const _hoisted_74 = { class: "value large risk-value" }
const _hoisted_75 = { class: "summary-row total" }
const _hoisted_76 = { class: "value large risk-value" }
const _hoisted_77 = {
  key: 2,
  class: "modal-content empty-state"
}
const _hoisted_78 = { class: "modal-footer" }

import type {
  NontaxComparisonItem,
  NontaxComparisonTotals,
} from '@/components/wage/common/CommonWageNontaxCompare.vue';
import NontaxDiffTooltipCell from '@/components/wage/common/NontaxDiffTooltipCell.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'NontaxComparePanel',
  props: {
    activeTab: {},
    currentYearMonth: {},
    comparisonData: {},
    totals: {},
    customLunch: {},
    noProductionNontax: { type: Boolean },
    beforeDescription: {},
    isGeneratingPdf: { type: Boolean },
    showClose: { type: Boolean, default: true },
    hideScenarioSettings: { type: Boolean, default: false }
  },
  emits: ["update:activeTab", "update:customLunch", "update:noProductionNontax", "setting-change", "generate-pdf", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const nc = (value: string | number | null | undefined): number => {
  if (value == null) return 0;
  return parseFloat(value.toString().replace(/,/g, '')) || 0;
};

const getDiffClass = (value: string, _isReverse = false): string => {
  const num = nc(value);
  if (num > 0) return 'highlight-green';
  if (num < 0) return 'highlight-red';
  return '';
};

const onCustomLunchInput = (value: string) => {
  emit('update:customLunch', value);
  emit('setting-change');
};

const onNoProductionChange = (value: boolean | null) => {
  emit('update:noProductionNontax', Boolean(value));
  emit('setting-change');
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h2", null, "임금개선 분석 보고서", -1)),
      (__props.showClose)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 0,
            class: "close-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("mdi-close", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "info-label" }, "조회 연월", -1)),
          _createElementVNode("span", _hoisted_6, _toDisplayString(__props.currentYearMonth), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "info-label" }, "대상 인원", -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(__props.comparisonData.length) + "명", 1)
        ])
      ])
    ]),
    (!__props.hideScenarioSettings)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "setting-title" }, "비과세 미적용 시나리오 설정", -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "setting-label" }, "중식비 금액 (전 직원 동일 적용)", -1)),
              _createVNode(_component_v_text_field, {
                "model-value": __props.customLunch,
                type: "text",
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                class: "lunch-input",
                placeholder: "0",
                "onUpdate:modelValue": onCustomLunchInput
              }, null, 8, ["model-value"]),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "setting-hint" }, "※ 현재 중식비가 더 작으면 현재 금액 유지", -1))
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_v_checkbox, {
                "model-value": __props.noProductionNontax,
                label: "생산직 비과세 모두 미적용 (연장/야간/휴일 수당 비과세 제외)",
                "hide-details": "",
                density: "compact",
                color: "primary",
                "onUpdate:modelValue": onNoProductionChange
              }, null, 8, ["model-value"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.comparisonData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_v_tabs, {
            "model-value": __props.activeTab,
            color: "primary",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('update:activeTab', $event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tab, { value: "detail" }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("상세 비교", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_tab, { value: "summary" }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("요약", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model-value"]),
          _createVNode(_component_v_window, { "model-value": __props.activeTab }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: "detail" }, {
                default: _withCtx(() => [
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "unit-label" }, "단위: 원", -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("table", _hoisted_15, [
                      _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", {
                            rowspan: "2",
                            class: "sticky-col col-no"
                          }, "No"),
                          _createElementVNode("th", {
                            rowspan: "2",
                            class: "sticky-col-name"
                          }, "사원명"),
                          _createElementVNode("th", { rowspan: "2" }, "직종"),
                          _createElementVNode("th", { rowspan: "2" }, "총급여"),
                          _createElementVNode("th", {
                            colspan: "4",
                            class: "before-header"
                          }, "비과세 미적용시"),
                          _createElementVNode("th", {
                            colspan: "4",
                            class: "after-header"
                          }, "비과세 적용시 (현재)"),
                          _createElementVNode("th", {
                            colspan: "4",
                            class: "diff-header"
                          }, "차액(비과세 미적용 - 적용(현재))"),
                          _createElementVNode("th", {
                            rowspan: "2",
                            class: "saving-header"
                          }, "절감액"),
                          _createElementVNode("th", {
                            rowspan: "2",
                            class: "risk-header"
                          }, [
                            _createTextVNode("통상임금"),
                            _createElementVNode("br"),
                            _createTextVNode("위험액")
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "before-header" }, "비과세"),
                          _createElementVNode("th", { class: "before-header" }, "기관부담"),
                          _createElementVNode("th", { class: "before-header" }, "퇴직금"),
                          _createElementVNode("th", { class: "before-header" }, "실수령"),
                          _createElementVNode("th", { class: "after-header" }, "비과세"),
                          _createElementVNode("th", { class: "after-header" }, "기관부담"),
                          _createElementVNode("th", { class: "after-header" }, "퇴직금"),
                          _createElementVNode("th", { class: "after-header" }, "실수령"),
                          _createElementVNode("th", { class: "diff-sub-header" }, "비과세"),
                          _createElementVNode("th", { class: "diff-sub-header" }, "기관부담"),
                          _createElementVNode("th", { class: "diff-sub-header" }, "퇴직금"),
                          _createElementVNode("th", { class: "diff-sub-header" }, "실수령")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.comparisonData, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_16, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", _hoisted_17, _toDisplayString(item.empName), 1),
                            _createElementVNode("td", _hoisted_18, _toDisplayString(item.empJob), 1),
                            _createElementVNode("td", _hoisted_19, _toDisplayString(item.total), 1),
                            _createElementVNode("td", _hoisted_20, _toDisplayString(item.before.nonTax), 1),
                            _createElementVNode("td", _hoisted_21, _toDisplayString(item.before.companyIns), 1),
                            _createElementVNode("td", _hoisted_22, _toDisplayString(item.before.retirement), 1),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(item.before.netPay), 1),
                            _createElementVNode("td", _hoisted_24, _toDisplayString(item.after.nonTax), 1),
                            _createElementVNode("td", _hoisted_25, _toDisplayString(item.after.companyIns), 1),
                            _createElementVNode("td", _hoisted_26, _toDisplayString(item.after.retirement), 1),
                            _createElementVNode("td", _hoisted_27, _toDisplayString(item.after.netPay), 1),
                            _createElementVNode("td", {
                              class: _normalizeClass(["diff-cell text-right", getDiffClass(item.diff.nonTax)])
                            }, [
                              _createVNode(NontaxDiffTooltipCell, {
                                text: item.diff.nonTax,
                                tooltip: item.diffTooltip?.nonTax
                              }, null, 8, ["text", "tooltip"])
                            ], 2),
                            _createElementVNode("td", {
                              class: _normalizeClass(["diff-cell text-right", getDiffClass(item.diff.companyIns, true)])
                            }, [
                              _createVNode(NontaxDiffTooltipCell, {
                                text: item.diff.companyIns,
                                tooltip: item.diffTooltip?.companyIns
                              }, null, 8, ["text", "tooltip"])
                            ], 2),
                            _createElementVNode("td", {
                              class: _normalizeClass(["diff-cell text-right", getDiffClass(item.diff.retirement, true)])
                            }, [
                              _createVNode(NontaxDiffTooltipCell, {
                                text: item.diff.retirement,
                                tooltip: item.diffTooltip?.retirement
                              }, null, 8, ["text", "tooltip"])
                            ], 2),
                            _createElementVNode("td", {
                              class: _normalizeClass(["diff-cell text-right", getDiffClass(item.diff.netPay)])
                            }, [
                              _createVNode(NontaxDiffTooltipCell, {
                                text: item.diff.netPay,
                                tooltip: item.diffTooltip?.netPay
                              }, null, 8, ["text", "tooltip"])
                            ], 2),
                            _createElementVNode("td", {
                              class: _normalizeClass(["saving-cell text-right font-bold", getDiffClass(item.saving, true)])
                            }, [
                              _createVNode(NontaxDiffTooltipCell, {
                                text: item.saving,
                                tooltip: item.diffTooltip?.saving
                              }, null, 8, ["text", "tooltip"])
                            ], 2),
                            _createElementVNode("td", _hoisted_28, [
                              _createVNode(NontaxDiffTooltipCell, {
                                text: item.ordinaryWageRiskMonthly,
                                tooltip: item.diffTooltip?.ordinaryWageRisk
                              }, null, 8, ["text", "tooltip"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", _hoisted_29, [
                          _cache[13] || (_cache[13] = _createElementVNode("td", {
                            class: "sticky-col col-no font-bold",
                            colspan: "3"
                          }, "합계", -1)),
                          _createElementVNode("td", _hoisted_30, _toDisplayString(__props.totals.total), 1),
                          _createElementVNode("td", _hoisted_31, _toDisplayString(__props.totals.before.nonTax), 1),
                          _createElementVNode("td", _hoisted_32, _toDisplayString(__props.totals.before.companyIns), 1),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(__props.totals.before.retirement), 1),
                          _createElementVNode("td", _hoisted_34, _toDisplayString(__props.totals.before.netPay), 1),
                          _createElementVNode("td", _hoisted_35, _toDisplayString(__props.totals.after.nonTax), 1),
                          _createElementVNode("td", _hoisted_36, _toDisplayString(__props.totals.after.companyIns), 1),
                          _createElementVNode("td", _hoisted_37, _toDisplayString(__props.totals.after.retirement), 1),
                          _createElementVNode("td", _hoisted_38, _toDisplayString(__props.totals.after.netPay), 1),
                          _createElementVNode("td", {
                            class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(__props.totals.diff.nonTax)])
                          }, [
                            _createVNode(NontaxDiffTooltipCell, {
                              text: __props.totals.diff.nonTax,
                              tooltip: __props.totals.diffTooltip?.nonTax
                            }, null, 8, ["text", "tooltip"])
                          ], 2),
                          _createElementVNode("td", {
                            class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(__props.totals.diff.companyIns, true)])
                          }, [
                            _createVNode(NontaxDiffTooltipCell, {
                              text: __props.totals.diff.companyIns,
                              tooltip: __props.totals.diffTooltip?.companyIns
                            }, null, 8, ["text", "tooltip"])
                          ], 2),
                          _createElementVNode("td", {
                            class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(__props.totals.diff.retirement, true)])
                          }, [
                            _createVNode(NontaxDiffTooltipCell, {
                              text: __props.totals.diff.retirement,
                              tooltip: __props.totals.diffTooltip?.retirement
                            }, null, 8, ["text", "tooltip"])
                          ], 2),
                          _createElementVNode("td", {
                            class: _normalizeClass(["diff-cell text-right font-bold", getDiffClass(__props.totals.diff.netPay)])
                          }, [
                            _createVNode(NontaxDiffTooltipCell, {
                              text: __props.totals.diff.netPay,
                              tooltip: __props.totals.diffTooltip?.netPay
                            }, null, 8, ["text", "tooltip"])
                          ], 2),
                          _createElementVNode("td", {
                            class: _normalizeClass(["saving-cell text-right font-bold", getDiffClass(__props.totals.saving, true)])
                          }, [
                            _createVNode(NontaxDiffTooltipCell, {
                              text: __props.totals.saving,
                              tooltip: __props.totals.diffTooltip?.saving
                            }, null, 8, ["text", "tooltip"])
                          ], 2),
                          _createElementVNode("td", _hoisted_39, [
                            _createVNode(NontaxDiffTooltipCell, {
                              text: __props.totals.ordinaryWageRiskMonthly,
                              tooltip: __props.totals.diffTooltip?.ordinaryWageRisk
                            }, null, 8, ["text", "tooltip"])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: "summary" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _cache[21] || (_cache[21] = _createElementVNode("h3", null, "비과세 미적용시", -1)),
                        _createElementVNode("p", _hoisted_43, _toDisplayString(__props.beforeDescription), 1),
                        _createElementVNode("div", _hoisted_44, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "총급여", -1)),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(__props.totals.total), 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "비과세", -1)),
                          _createElementVNode("span", _hoisted_47, _toDisplayString(__props.totals.before.nonTax), 1)
                        ]),
                        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_48, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "기관부담 4대보험", -1)),
                          _createElementVNode("span", _hoisted_49, _toDisplayString(__props.totals.before.companyIns), 1)
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "퇴직금", -1)),
                          _createElementVNode("span", _hoisted_51, _toDisplayString(__props.totals.before.retirement), 1)
                        ]),
                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_52, [
                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "실수령액", -1)),
                          _createElementVNode("span", _hoisted_53, _toDisplayString(__props.totals.before.netPay), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _cache[29] || (_cache[29] = _createElementVNode("h3", null, "비과세 적용시 (현재)", -1)),
                        _cache[30] || (_cache[30] = _createElementVNode("p", { class: "card-desc" }, "생산직비과세 적용 (연장/야간/휴일 포함)", -1)),
                        _createElementVNode("div", _hoisted_55, [
                          _cache[24] || (_cache[24] = _createElementVNode("span", { class: "label" }, "총급여", -1)),
                          _createElementVNode("span", _hoisted_56, _toDisplayString(__props.totals.total), 1)
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "label" }, "비과세", -1)),
                          _createElementVNode("span", _hoisted_58, _toDisplayString(__props.totals.after.nonTax), 1)
                        ]),
                        _cache[31] || (_cache[31] = _createElementVNode("div", { class: "divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_59, [
                          _cache[26] || (_cache[26] = _createElementVNode("span", { class: "label" }, "기관부담 4대보험", -1)),
                          _createElementVNode("span", _hoisted_60, _toDisplayString(__props.totals.after.companyIns), 1)
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "label" }, "퇴직금", -1)),
                          _createElementVNode("span", _hoisted_62, _toDisplayString(__props.totals.after.retirement), 1)
                        ]),
                        _cache[32] || (_cache[32] = _createElementVNode("div", { class: "divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_63, [
                          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "label" }, "실수령액", -1)),
                          _createElementVNode("span", _hoisted_64, _toDisplayString(__props.totals.after.netPay), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _cache[38] || (_cache[38] = _createElementVNode("h3", null, "기관 비용 절감 효과", -1)),
                        _createElementVNode("div", _hoisted_66, [
                          _cache[33] || (_cache[33] = _createElementVNode("span", { class: "label" }, "대상 인원", -1)),
                          _createElementVNode("span", _hoisted_67, _toDisplayString(__props.comparisonData.length) + "명", 1)
                        ]),
                        _cache[39] || (_cache[39] = _createElementVNode("div", { class: "divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_68, [
                          _cache[34] || (_cache[34] = _createElementVNode("span", { class: "label" }, "기관부담 4대보험 차액", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["value", getDiffClass(__props.totals.diff.companyIns, true)])
                          }, _toDisplayString(__props.totals.diff.companyIns), 3)
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _cache[35] || (_cache[35] = _createElementVNode("span", { class: "label" }, "퇴직금 차액", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["value", getDiffClass(__props.totals.diff.retirement, true)])
                          }, _toDisplayString(__props.totals.diff.retirement), 3)
                        ]),
                        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_70, [
                          _cache[36] || (_cache[36] = _createElementVNode("span", { class: "label" }, "월 절감액", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["value large", getDiffClass(__props.totals.saving, true)])
                          }, _toDisplayString(__props.totals.saving), 3)
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "label" }, "연간 절감 예상액", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["value", getDiffClass(__props.totals.saving, true)])
                          }, _toDisplayString(__props.totals.yearSaving), 3)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _cache[43] || (_cache[43] = _createElementVNode("h3", null, "통상임금 위험액", -1)),
                        _cache[44] || (_cache[44] = _createElementVNode("p", { class: "card-desc" }, "중식비·직책수당 통상임금 포함 시 연장·야간·퇴직·연차 소급 추정", -1)),
                        _createElementVNode("div", _hoisted_73, [
                          _cache[41] || (_cache[41] = _createElementVNode("span", { class: "label" }, "1년 추정치", -1)),
                          _createElementVNode("span", _hoisted_74, _toDisplayString(__props.totals.ordinaryWageRisk1Year), 1)
                        ]),
                        _cache[45] || (_cache[45] = _createElementVNode("div", { class: "divider" }, null, -1)),
                        _createElementVNode("div", _hoisted_75, [
                          _cache[42] || (_cache[42] = _createElementVNode("span", { class: "label" }, "3년 추정치", -1)),
                          _createElementVNode("span", _hoisted_76, _toDisplayString(__props.totals.ordinaryWageRisk), 1)
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model-value"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_77, [...(_cache[46] || (_cache[46] = [
          _createElementVNode("p", null, "데이터가 없습니다.", -1)
        ]))])),
    _createElementVNode("div", _hoisted_78, [
      _createVNode(_component_v_btn, {
        variant: "flat",
        class: "btn-search",
        disabled: __props.comparisonData.length === 0,
        loading: __props.isGeneratingPdf,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('generate-pdf')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, {
            left: "",
            size: "small"
          }, {
            default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
              _createTextVNode("mdi-file-pdf-box", -1)
            ]))]),
            _: 1
          }),
          _cache[48] || (_cache[48] = _createTextVNode(" PDF 출력 ", -1))
        ]),
        _: 1
      }, 8, ["disabled", "loading"]),
      _createVNode(_component_v_spacer),
      (__props.showClose)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            variant: "text",
            class: "btn-cancel",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('close')))
          }, {
            default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
              _createTextVNode("닫기", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})